import { SheetModeRenderOrders } from "@/modes/sheet-mode/sheet-mode-render-orders";
import { useAppSelector } from "@/store/store-hooks";
import {
  MapUserMarker as MapUserMarkerRenderer,
  selectIElementWorldTransform,
  UserLocation,
  UserLocationNoFov,
  useSvg,
} from "@faro-lotv/app-component-toolbox";
import { IElementGenericImgSheet } from "@faro-lotv/ielement-types";
import type { JSX } from "react";
import { Camera } from "three";

export type MapUserRendererProps = {
  /** the camera that represents the user */
  userCamera: Camera;

  /** sheet whose elevation will be used for the pano */
  sheetForElevation?: IElementGenericImgSheet;

  /** True if the view cone of the user marker should be visible */
  shouldShowViewCone: boolean;
};

/**
 * @returns A renderer for placeholders for floorplans and panorama images
 */
export function MapUserMarker({
  userCamera,
  sheetForElevation,
  shouldShowViewCone,
}: MapUserRendererProps): JSX.Element | null {
  const pos = useAppSelector(
    selectIElementWorldTransform(sheetForElevation?.id),
  );

  const texture = useSvg(
    shouldShowViewCone ? UserLocation : UserLocationNoFov,
    {
      width: 512,
      height: 512,
      generateMipmaps: true,
    },
  );

  if (!texture) {
    return null;
  }

  return (
    <MapUserMarkerRenderer
      userCamera={userCamera}
      sheetPosition={pos.position}
      texture={texture}
      renderOrder={SheetModeRenderOrders.MinimapUserMarker}
    />
  );
}
